import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-premises-details-ehms.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-premises-details-ehms.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MapService } from "../../../../../map/shared/map.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationPremisesDetailsEhmsConstants } from "./create-application-premises-details-ehms.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../../app-controller.service";
import { AlertType } from "../../../../../shared/models/alert";
import { HttpClient } from "@angular/common/http";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { MapTools } from "../../../../../map/shared/map.tools";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ApiEhmsConstants } from "../../../../../shared/constants/api-constants/api-ehms.constants";
import { phoneNumberValidator } from "../../../../../shared/classes/phone-number-validator";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let CreateApplicationPremisesDetailsEhmsComponent = class CreateApplicationPremisesDetailsEhmsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    mapTools;
    http;
    requestStatusService;
    changeDetectorRefs;
    active;
    premisesEndpoint;
    propertiesForm;
    descriptionLabel1 = CreateApplicationPremisesDetailsEhmsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationPremisesDetailsEhmsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationPremisesDetailsEhmsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationPremisesDetailsEhmsConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationPremisesDetailsEhmsConstants.VALIDATION_MESSAGES;
    nameControl = CreateApplicationPremisesDetailsEhmsConstants.NAME_CONTROL;
    addressControl = CreateApplicationPremisesDetailsEhmsConstants.ADDRESS_CONTROL;
    postalAddressControl = CreateApplicationPremisesDetailsEhmsConstants.POSTAL_ADDRESS_CONTROL;
    telephoneControl = CreateApplicationPremisesDetailsEhmsConstants.TELEPHONE_CONTROL;
    emailControl = CreateApplicationPremisesDetailsEhmsConstants.EMAIL_CONTROL;
    faxControl = CreateApplicationPremisesDetailsEhmsConstants.FAX_CONTROL;
    cellphoneControl = CreateApplicationPremisesDetailsEhmsConstants.CELLPHONE_CONTROL;
    premisesTypeControl = CreateApplicationPremisesDetailsEhmsConstants.PREMISES_TYPE_CONTROL;
    ownerControl = CreateApplicationPremisesDetailsEhmsConstants.OWNER_CONTROL;
    contactsControl = CreateApplicationPremisesDetailsEhmsConstants.CONTACTS_CONTROL;
    nameTextPlaceHolder = CreateApplicationPremisesDetailsEhmsConstants.NAME_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationPremisesDetailsEhmsConstants.ADDRESS_TEXT_PLACEHOLDER;
    postalAddressTextPlaceHolder = CreateApplicationPremisesDetailsEhmsConstants.POSTAL_ADDRESS_TEXT_PLACEHOLDER;
    telephoneTextPlaceHolder = CreateApplicationPremisesDetailsEhmsConstants.TELEPHONE_TEXT_PLACEHOLDER;
    emailTextPlaceHolder = CreateApplicationPremisesDetailsEhmsConstants.EMAIL_TEXT_PLACEHOLDER;
    faxTextPlaceHolder = CreateApplicationPremisesDetailsEhmsConstants.FAX_TEXT_PLACEHOLDER;
    cellphoneTextPlaceHolder = CreateApplicationPremisesDetailsEhmsConstants.CELLPHONE_TEXT_PLACEHOLDER;
    premisesTypeTextPlaceHolder = CreateApplicationPremisesDetailsEhmsConstants.PREMISES_TYPE_TEXT_PLACEHOLDER;
    zoneLabel = CreateApplicationPremisesDetailsEhmsConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = CreateApplicationPremisesDetailsEhmsConstants.ADD_ZONE_LABEL;
    ownerLabel = CreateApplicationPremisesDetailsEhmsConstants.OWNER_LABEL;
    contactsLabel = CreateApplicationPremisesDetailsEhmsConstants.CONTACTS_LABEL;
    copyApplicantToOwnerZoneLabel = CreateApplicationPremisesDetailsEhmsConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    copyApplicantToContactsZoneLabel = CreateApplicationPremisesDetailsEhmsConstants.COPY_APPLICANT_TO_CONTACTS_LABEL;
    copyOwnerToContactsZoneLabel = CreateApplicationPremisesDetailsEhmsConstants.COPY_OWNER_TO_CONTACTS_LABEL;
    removePropertyLabel = CreateApplicationPremisesDetailsEhmsConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    contactsDisableFilterBy = true;
    contactsDisableAdd = false;
    contactsDisableEditing = false;
    contactsGroups = [];
    sketch;
    ownerListLabel = "Owner";
    zones = [];
    premisesTypes = [];
    mapComponent;
    isMapLoaded = false;
    getPremisesQuerySubscription;
    selectedPremisesSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, mapService, mapTools, http, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.http = http;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
        this.premisesEndpoint = ApiEhmsConstants.PREMISES_URL;
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.premisesTypes = [];
        if (this.aflaModuleStrategyService.lookups.has("PremisesType")) {
            this.premisesTypes = this.aflaModuleStrategyService.lookups.get("PremisesType");
        }
        else {
            this.getLookups();
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and name eq 'PremisesType'`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationPremisesDetailsEhmsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const premisesTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "PremisesType") {
                    premisesTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("PremisesType", premisesTypes);
        this.premisesTypes = premisesTypes;
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPremisesEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.sketch.on("create", (event) => {
            if (event.state === "start") {
                this.mapService.showPopups = false;
            }
            if (event.state === "complete") {
                this.mapService.showPopups = true;
                if (event.graphic.geometry.type === "point") {
                    this.setPropertyData(null, event.graphic.geometry);
                }
            }
            else if (event.state === "cancel") {
                this.mapService.showPopups = true;
            }
            else {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.contactsGroups = stepMeta.contactGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    getProperties() {
        return this.propertiesForm.get("premises");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const nameControl = propertyControl.get(this.nameControl);
        const addressControl = propertyControl.get(this.addressControl);
        const postalAddressControl = propertyControl.get(this.postalAddressControl);
        if (nameControl.value !== undefined && nameControl.value !== null && nameControl.value.trim() !== "") {
            nameControl.setValidators(Validators.required);
            addressControl.clearValidators();
            postalAddressControl.clearValidators();
        }
        else if ((addressControl.value !== undefined && addressControl.value !== null && addressControl.value.trim() !== "") ||
            (postalAddressControl.value !== undefined && postalAddressControl.value !== null && postalAddressControl.value.trim() !== "")) {
            nameControl.clearValidators();
            addressControl.setValidators(Validators.required);
            postalAddressControl.setValidators(Validators.required);
        }
        else {
            nameControl.setValidators(Validators.required);
            addressControl.setValidators(Validators.required);
            postalAddressControl.setValidators(Validators.required);
        }
        nameControl.updateValueAndValidity();
        addressControl.updateValueAndValidity();
        postalAddressControl.updateValueAndValidity();
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToContactsClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const contactsFormControl = this.getProperties().controls[propertyIndex].get("contacts");
        this.recipientListService.addRecipient(applicant, true, contactsFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyOwnerToContactsClicked(propertyIndex) {
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        const ownersList = ownersFormControl.value ? ownersFormControl.value.recipients : [];
        const contactsFormControl = this.getProperties().controls[propertyIndex].get("contacts");
        const contactsList = contactsFormControl.value ? contactsFormControl.value.recipients : [];
        ownersList.forEach((item) => {
            if (item.selected) {
                contactsList.push(item);
            }
        });
        this.recipientListService.setRecipients(contactsList, true, contactsFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("premisesForm");
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        if (propertyObject) {
            const newPremises = new FormGroup({
                id: new FormControl(propertyObject.Id),
                name: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Name", "name"), [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                postalAddress: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PostalAddress", "portalAddress"), [Validators.required]),
                telephone: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TelephoneNumber", "telephoneNumber"), [Validators.required, phoneNumberValidator]),
                email: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Email", "email"), [Validators.email]),
                fax: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Fax", "fax"), [phoneNumberValidator]),
                cellphone: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Cellphone", "cellphone"), [phoneNumberValidator]),
                premiseType: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PremisesType", "premisesType")),
                moduleId: new FormControl(propertyObject.ModuleId),
                geometry: new FormControl(geometry),
                owners: new FormControl(null),
                contacts: new FormControl(null)
            });
            this.getPropertyOwners(propertyObject.Id, newPremises);
        }
        else {
            const newPremises = new FormGroup({
                id: new FormControl(0),
                name: new FormControl(null, [Validators.required]),
                address: new FormControl(null, [Validators.required]),
                postalAddress: new FormControl(null, [Validators.required]),
                telephone: new FormControl(null, [Validators.required]),
                email: new FormControl(null, [Validators.email]),
                fax: new FormControl(null),
                cellphone: new FormControl(null),
                premiseType: new FormControl(null),
                moduleId: new FormControl(Number(this.appController.selectedModuleID)),
                geometry: new FormControl(geometry),
                owners: new FormControl(null),
                contacts: new FormControl(null)
            });
            this.getPropertyOwners(null, newPremises);
        }
    }
    getPremisesQuery(params) {
        return this.http.get(this.premisesEndpoint, { params });
    }
    createRecipientObject(item) {
        return {
            id: 0,
            name: item.name,
            surname: item.surname,
            telephone: item.telephone,
            email: item.email,
            defaultCommunicationMethod: item.defaultCommunicationMethod,
            postalAddress: item.postalAddress,
            designation: item.designation,
            organisation: item.organisation,
            clientVatNumber: item.clientVatNumber,
            streetAddress: item.streetAddress,
            homePhone: item.homePhone,
            idNumber: item.idNumber,
            organisationRegistrationNumber: item.organisationRegistrationNumber,
            representative: item.representative,
            fax: item.fax,
            cellphone: item.cellphone,
            streetSuburb: item.streetSuburb,
            streetCity: item.streetCity,
            streetProvince: item.streetProvince,
            streetCode: item.streetCode,
            postalSuburb: item.postalSuburb,
            postalCity: item.postalCity,
            postalProvince: item.postalProvince,
            postalCode: item.postalCode,
            postalCountry: item.postalCountry,
            streetCountry: item.streetCountry,
            professionalBody: item.professionalBody,
            professionalBodyRegNum: item.professionalBodyRegNum,
            groups: []
        };
    }
    getPremisesOwners(id, newPremises) {
        const params = {
            $expand: "owners, contacts",
            $filter: `id eq ${id}`
        };
        this.getPremisesQuerySubscription = this.getPremisesQuery(params).subscribe({
            next: (response) => {
                const premisesOwners = response.value[0].owners;
                const premisesContacts = response.value[0].contacts;
                const ownersControl = newPremises.get("owners");
                const contactsControl = newPremises.get("contacts");
                const owners = [];
                const contacts = [];
                premisesOwners.forEach(item => {
                    try {
                        const newOwner = this.createRecipientObject(item);
                        owners.push(newOwner);
                    }
                    catch {
                        this.appController.showMessage(CreateApplicationPremisesDetailsEhmsConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                    }
                }, (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.showMessage(error.message, AlertType.Error);
                });
                premisesContacts.forEach(item => {
                    try {
                        const newContact = this.createRecipientObject(item);
                        contacts.push(newContact);
                    }
                    catch {
                        this.appController.showMessage(CreateApplicationPremisesDetailsEhmsConstants.INVALID_CONTACT_ATTRIBUTE, AlertType.Error);
                    }
                }, (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.showMessage(error.message, AlertType.Error);
                });
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newPremises);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                if (owners.length > 0) {
                    // this.recipientListService.setRecipients(owners, true, ownersControl);
                    ownersControl.setValue(owners);
                }
                if (contacts.length > 0) {
                    // this.recipientListService.setRecipients(owners, true, ownersControl);
                    contactsControl.setValue(contacts);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            },
            error: (error) => {
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                this.requestStatusService.removeBusySpinner("continueToNextStep");
            }
        });
    }
    getPropertyOwners(premisesId, newPremises) {
        if (premisesId) {
            this.getPremisesOwners(premisesId, newPremises);
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newPremises);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Premises graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPremisesSubscription = this.mapService.$selectedPremises.subscribe(premises => {
            if (premises !== null) {
                this.setPropertyData(premises.attributes, premises.geometry);
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: MapService },
        { type: MapTools },
        { type: HttpClient },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationPremisesDetailsEhmsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-premises-details-ehms",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationPremisesDetailsEhmsComponent);
export { CreateApplicationPremisesDetailsEhmsComponent };
